module.exports = __webpack_public_path__ + "static/media/vf_mpants_core.2906b5bd.svg";